<template>
    <div>
        <div  v-if="portal && portal.welcome_message">
            <h1 v-html="portal.welcome_message"></h1>
            <br>
        </div>
<!--        <booking-flayer :from-wp="true"/>-->
        <new-booking-flayer :from-wp="true"/>
        <div class="booking-flyier portal-content" style="margin-top: 50px;" v-if="portal && (portal.logo_path || portal.top_message || portal.special_offer)">

            <div class="clearfix">
                <div class="col-sm-3 col-md-2 col-xs-4 col-xs-offset-4 col-sm-offset-0" v-if="portal.logo_path">
                    <img v-if="portal.logo_path" class="img-responsive" :src="portal.logo_path" />
                </div>
                <div :class="[portal.logo_path ? 'col-sm-9 col-md-10 col-xs-12' : 'col-sm-12 col-xs-12']"  v-html="portal.top_message"></div>
            </div>

            <div class="text-center m-t-20" v-if="portal.special_offer">

                <button type="button" data-toggle="modal" data-target="#special-offer-modal" class="btn btn-blue">{{trans('WpStep1.SpecialOffer','Special Offer')}}</button>

            </div>

        </div>


        <div class="booking-flyier" style="margin-top: 50px;" v-if="portal && portal.bottom_message">

            <div class="row">
                <div class="col-sm-12" v-html="portal.bottom_message"></div>
            </div>

        </div>

        <div id="special-offer-modal" class="modal fade" role="dialog">
            <div class="modal-dialog modal-sm">
                <!-- Modal content-->
                <div class="modal-content">
                    <div class="modal-body" v-if="portal">
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                        <div v-html="portal.special_offer_text"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>
<script>
// import BookingFlayer from "../../layouts/BookingFlayer";
import NewBookingFlayer from "../../layouts/NewBookingFlayer";
import {mapState} from "vuex";
export default {
    name: 'WpStep1',
    components: {NewBookingFlayer},
    mounted() {
        var currentUrl = new URL(window.location.href);
        var urlParams = new URLSearchParams(currentUrl.search);
        console.log({'step1': window.location.search})
        this.$store.dispatch('setStep1Params', window.location.search)

        if (urlParams.has('portal_name')) {
            console.log(urlParams.get('portal_name'))
            this.$store.dispatch('fetchPortalData', {'url_code': urlParams.get('portal_name')});

            //Portal header and footer menus need to open in new browser tab
            // $('a:not([href^="#"]):not([href^="javascript:"]):not([href^="tel:"])').attr('target', '_blank');
        } else {
            console.log('no portal')
        }
        document.body.classList.remove('bg-body-light')
        document.body.classList.add('bg-gray')
    },
    computed: {
        ...mapState(['portal']),
    },
    methods: {
        trans(key, defaultValue,msg=null) {
            let translation = '';
            if(msg){
                translation = this.$t(key,{message:msg});
            }else{
                translation = this.$t(key);
            }
            return translation !== key ? translation : defaultValue;
        },
    }
}
</script>

